import { OnInit, Component, Input, ViewChild, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import _moment from 'proxies/dayjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ChartService } from '../../services/chart.service';


@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    standalone: false
})
export class ChartComponent implements OnInit {
  @Input() data: any;
  @Input() hideLabels: any;
  @Input() chartDataSets: any;
  @Input() chartLabels: any;
  @Input() chartOptions: any;
  @Input() chartColors: any;
  @Input() chartLegend: any;
  @Input() chartPlugins: any;
  @Input() chartType: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  @Input() zoomIn:boolean;
  intervals: any = [];
  filterType = 'fixed';
  timePeriodList: any;
  chartData: any;
  tableDataSets: any;
  config: any = {isCached:false};
  @ViewChild('kxChart') kxChart: any;

  constructor(private baseService: BaseService, 
    private appService: AppService, 
    private loader: LoaderService,
    public router: Router,
    public dialogService:DialogService,
    public storage: StorageService,
    public chartService: ChartService,
    public alerts: AlertsService
    ) {
      this.intervals = this.chartService.getAllIntervals();
  }

  ngOnInit() {
    if (this.data) {
      this.chartService.getTimePeriod((timePeriodList)=>{
        this.timePeriodList = timePeriodList;
      })
      this.chartService.getWidget(this.data,(res)=>{
        this.data = res.data;
        res.chartOptions.onClick =  (evt, array) => {
          this.chartOnClick(evt,array);
        };
        this.chartOptions = res.chartOptions;
        this.chartType = this.data.type;
        this.getIntervalList();
      });
    }
  }

  makeFullScreen(fullScreen) {
    if(!fullScreen &&  this.chartDataSets.length <= 5){
      //if dataset length is less than 5 then label should always be visible
      fullScreen = true;
    }else if(!fullScreen &&  this.chartDataSets.length > 30){
      //if dataset length is less than 5 then label should never be visible
      fullScreen = false;
    }
    this.chartOptions["legend"]["display"] = fullScreen;
    this.chartOptions = {... this.chartOptions};
  }

  public chartOnClick(evt: any,array:any): void {
    this.data.filterType = this.filterType;
   this.chartService.chartClick(evt,array,this.kxChart,this.data,this.chartType);
  }
 
  prepareData() {
    this.loader.showSpinner();
    if(this.filterType == 'custom' && (this.data.from==null || this.data.to==null))
      this.alerts.error('Please specify correct date range.')
    else{
      this.data = this.chartService.prepareChartPayload(this.filterType,this.data);
      this.chartService.loadChartData(this.data, (response) => {
        if(Object.keys(response).length>0){          
          this.chartDataSets = response.chartDataSets;
          this.chartLabels = response.chartLabels;          
          if(this.chartDataSets != null && this.chartDataSets.length>5){
            this.chartOptions["legend"]["display"] = false;
          }else{
            this.chartOptions["legend"]["display"] = true;
          }
          if(response.isCached != undefined){
            this.config.isCached  = response.isCached
          }else{
            this.config.isCached = false;
          }
        }else{
          this.emptyData();
          this.config.isCached = false;
        }
        this.loader.hideSpinner()
    })
  }
  }

  refreshData(){
    var key = this.chartService.getChartKey(this.data);
    this.storage.removeData(key,()=>{
      this.prepareData();
    })
  }

  setFilter(event) {
    console.log('eventis', event)
    this.data.time_period = event.target.value;
    this.configChanged.emit({config:{time_period:this.data.time_period}})
    this.getIntervalList();
  }
  setInterval(event) {
    console.log('eventis', event)
    this.data.interval = event.target.value;
    this.getData();
  }

  getData(){
    if(this.filterType == 'fixed'){
      this.configChanged.emit({config:{interval:this.data.interval}})
      this.prepareData();
    }
  }
  getIntervalList() {
    this.intervals = this.chartService.getIntervalList(this.data);
    if (!this.intervals.includes(this.data.interval)){
      this.data.interval = this.intervals[this.intervals.length - 1]
    }
    this.prepareData();
  }

  emptyData() {
    this.chartDataSets = [{ data: [0], label: "Sample" }]
    this.chartLabels = this.chartLabels ? this.chartLabels : ["Sample"]
  }
  valueChange(e,q){
   var res = this.chartService.valueChange(e,q,this.data);
   if(res){
     this.prepareData();
   }   
  }
  intervalsBasedOnCustomRange(diff){
   this.chartService.intervalsBasedOnCustomRange(this.filterType);
  }
}
